import Link from "gatsby-link";
import Winners from "../../../../src/images/22_Winners.jpg";
import MarketoForm from "../../../../src/components/marketo-form";
import * as React from 'react';
export default {
  Link,
  Winners,
  MarketoForm,
  React
};